import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createSection17OrderRequestsAPI,
  updateSection17OrderRequestsAPI,
  getSection17OrderRequestsByCaseIDAPI,
  deleteSection17OrderRequestsAPI,
} from "../../../api/Sec17OrderRequests_api";

export const getSection17OrderRequestsByCaseIDAction = createAsyncThunk(
  "sec17OrderRequests/getSection17OrderRequestsByCase",
  async (caseID, { rejectWithValue }) => {
    const response = await getSection17OrderRequestsByCaseIDAPI(caseID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const createSection17OrderRequestsAction = createAsyncThunk(
  "sec17OrderRequests/createSection17OrderRequests",
  async (section17OrderRequestsData, { rejectWithValue }) => {
    const response = await createSection17OrderRequestsAPI(
      section17OrderRequestsData,
    );
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const updateSection17OrderRequestsAction = createAsyncThunk(
  "sec17OrderRequests/updateSection17OrderRequests",
  async (
    { section17OrderRequests_ID, section17OrderRequestsData },
    { rejectWithValue },
  ) => {
    const response = await updateSection17OrderRequestsAPI(
      section17OrderRequests_ID,
      section17OrderRequestsData,
    );

    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const deleteSection17OrderRequestsAction = createAsyncThunk(
  "sec17OrderRequests/deleteSection17OrderRequests",
  async (section17OrderRequests_ID, { rejectWithValue }) => {
    const response = await deleteSection17OrderRequestsAPI(
      section17OrderRequests_ID,
    );
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);
